import { InjectionToken } from '@angular/core';

export const APP_SETTINGS = new InjectionToken<AppSettings>('AppSettings');

export interface AppSettings {
  gatewayUrl: string;
  ocpApimSubscriptionKey: string;
  tradeApiOcpKey:string;
  tradeBaseAPIUrl : string;
  gatewayAPIUrl : string;
  gatewayApiOcpKey : string;
  gatewayBoAPIUrl : string;
  BoAPIUrlOcpKey : string
  orgId : string;
  accessTokenForJwtUrl : string;
}
